import { render } from "./ShopCartTable.vue?vue&type=template&id=279f778b&scoped=true&bindings={\"cart\":\"options\",\"itemPrice\":\"options\"}"
import script from "./ShopCartTable.vue?vue&type=script&lang=js"
export * from "./ShopCartTable.vue?vue&type=script&lang=js"

import "./ShopCartTable.vue?vue&type=style&index=0&id=279f778b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-279f778b"

export default script